<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area esg02">
      <div class="tit_area">
        <div class="sub_tit">나눔경영</div>
        <div class="sub_txt">
          따뜻하고 풍요로운 사회를 만들기 위해 노력하고 있습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <h3 class="h3_tit gs_y">사회공헌 전략</h3>
      <div class="tit_sub gs_y">
        일회성으로 끝나거나 진정성이 없는 활동은 지양하고, 계열사와 함께
        지역사회와 어린이를 대상으로 안전하고 쾌적한 환경을 만드는데 앞장서며,
        핵심 비즈니스와 <br />연계하여 한국오션플랫폼의 역량을 가장 효과적으로
        활용할 수 있는 사회공헌활동을 적극 개발하여 실행하고 있습니다.
      </div>
      <div class="img_wrap mgt40 gs_y">
        <img
          :src="`${resources}img/img_esg_01_01-1.jpg`"
          alt="미래 세대를 위한 지역사회 환경 개선 및 밝고 안전한 미래 만들기 - 지역사회 : 공급권역 및 생산 거점 위주의 대상 지역 선정, 아동ㆍ어린이 : 경제ㆍ사회적 취약계층 중 아동ㆍ어린이로 대상 집중, 환경 및 안전 : UN 아동권리협약 의거 환경과 안전 최우선 지원,  업(業)과 연계 : 핵심 비즈니스 연계 사회공헌활동 발굴 및 진행"
        />
      </div>

      <!--
      <div class="esg_cont_list01 mgt60 gs_y">
        <div class="esg_cont_img">
          <img :src="`${resources}img/img_esg_01_02.jpg`" alt="" />
        </div>
        <div class="esg_cont_txt">
          <p class="esg_tit">사랑의 후원품 전달</p>
          <div class="esg_txt">
            충청북도 아산시 영인면 주민센터와 함께 하는 행복키움 추진단에게 지역
            독거주민에게 지급되는 밀키트, 반찬 지원 사업에 도움이 되고자,
            아산공장에서 냉동고를 기증하였습니다.
          </div>
        </div>
      </div>
      <div class="esg_cont_list01 gs_y">
        <div class="esg_cont_img">
          <img :src="`${resources}img/img_esg_01_03.jpg`" alt="" />
        </div>
        <div class="esg_cont_txt">
          <p class="esg_tit">학교 발전 장학금 지원</p>
          <div class="esg_txt">
            충청북도 음성군 오갑초등학교에 학생들의 장학금 등의 목적으로
            사용되는 학교 발전 장학금을 음성공장에서 기증하였습니다.
          </div>
        </div>
      </div>
      -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page],
  mounted() {
    this.initTween();
  }
};
</script>

<style lang="scss" scoped></style>
